"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VbzInputText = void 0;
const react_1 = __importStar(require("react"));
const reactstrap_1 = require("reactstrap");
const className_1 = require("../../utils/className");
exports.VbzInputText = (_a) => {
    var { id, type = 'text', value, name, textLabel, labelId = '', defaultValue = '', className = '', disabled = false, errorMessage = 'Error message', forceError = false, icon, maxLength, placeholder, inputMode, pattern, regex = undefined, errorId = 'lbl_msgInvalid_1', ref, debouncedTime = 500, onChange = () => undefined, onFocus = () => undefined, onBlur = () => undefined, validate = () => true, onKeyPress = () => undefined } = _a, rest = __rest(_a, ["id", "type", "value", "name", "textLabel", "labelId", "defaultValue", "className", "disabled", "errorMessage", "forceError", "icon", "maxLength", "placeholder", "inputMode", "pattern", "regex", "errorId", "ref", "debouncedTime", "onChange", "onFocus", "onBlur", "validate", "onKeyPress"]);
    const [isFocused, setIsFocused] = react_1.useState(false);
    const [isValidInput, setIsValidInput] = react_1.useState(true);
    const [isTyping, setIsTyping] = react_1.useState(false);
    const [isFilled, setIsFilled] = react_1.useState(false);
    const [innerValue, setInnerValue] = react_1.useState('');
    const enableOutline = react_1.useCallback((e) => {
        setIsFocused(true);
        onFocus(e);
    }, []);
    const disableOutline = react_1.useCallback((e) => {
        setIsFocused(false);
        onBlur(e);
    }, []);
    const handleDebouncedValue = () => {
        const hasValue = innerValue.length > 0;
        setIsTyping(false);
        setIsFilled(hasValue);
        setIsValidInput(hasValue ? validate(innerValue) : true);
    };
    react_1.useEffect(() => {
        setIsValidInput(true);
        const debounceTimeout = setTimeout(handleDebouncedValue, debouncedTime);
        return () => {
            clearTimeout(debounceTimeout);
        };
    }, [innerValue]);
    react_1.useEffect(() => {
        return setInnerValue(() => {
            if (value)
                return value;
            return '';
        });
    }, [value]);
    const handleOnChange = react_1.useCallback((event) => {
        const text = event.target.value;
        setIsTyping(true);
        if (regex && Boolean(text.match(regex)))
            return;
        onChange(event);
        setInnerValue(text);
    }, [regex]);
    const generateId = () => {
        if (id)
            return id;
        if (typeof textLabel === 'string') {
            return textLabel;
        }
        return `${+new Date()}`;
    };
    return (react_1.default.createElement("div", { className: className_1.mapToCssModules([
            'input-group',
            disabled ? 'disabled' : '',
            isTyping ? 'typing' : '',
            isFilled ? 'filled' : '',
            isFocused ? 'input-outline' : '',
            !isValidInput || forceError ? 'error' : '',
            icon ? 'icon' : '',
        ]) },
        textLabel && (react_1.default.createElement("label", { id: labelId, htmlFor: generateId(), style: { display: 'flex' } }, textLabel)),
        react_1.default.createElement("div", null,
            react_1.default.createElement(reactstrap_1.Input, Object.assign({ id: generateId(), name: name, type: type, inputMode: inputMode, defaultValue: defaultValue, className: className, disabled: disabled, value: innerValue, ref: ref, onChange: handleOnChange, onFocus: enableOutline, onBlur: disableOutline, placeholder: placeholder, maxLength: maxLength, pattern: pattern, onKeyPress: onKeyPress }, rest)),
            icon),
        react_1.default.createElement("div", { className: "input-error" }, (!isValidInput || forceError) && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("i", { className: "material-icons" }, "error_outline"),
            react_1.default.createElement("label", { id: errorId, htmlFor: "input-text" }, errorMessage))))));
};
//# sourceMappingURL=index.js.map